
import { TableConfig, DataTable } from "@app/interfaces";

export class BrokerGroupLicenseTableConfig implements DataTable {

    constructor() { }

    static configure(): TableConfig {

        const tableConfig: TableConfig = {
            key: 'items',
            searchPanel: false,
            groupPanel: false,
            canAdd: true,
            canEdit: true,
            fields: [
                {
                    caption: 'From',
                    dataField: 'from',
                    dataType: "date",
                    format: "dd/MM/yyy"
                },
                {
                    caption: 'To',
                    dataField: 'to',
                    dataType: "date",
                    format: "dd/MM/yyy"
                },
                {
                    caption: 'Rate',
                    dataField: 'rate',
                    dataType: "number",
                }
            ]
        };

        return tableConfig;

    }

}